import './styles.scss'
import * as React from 'react'

import { SelectWithLabel, LabelButton, Button } from 'components/Form'
import InputControls from 'components/common/InputControls'
import DaysRange from '../DaysRange'
import CalendarPicker from 'components/CalendarPicker'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'

const Index = (props) => {
  const options = [
    lang('dashboard_every-day'),
    lang('dashboard_weekday'),
    lang('dashboard_personalized')
  ]
  const [selectedOptionAi, setSelectedOptionAi] = React.useState({ value: '', label: lang('dashboard_every-day') })
  const [shouldRefresh, setShouldRefresh] = React.useState(false)
  const [aiBotSchedules, setAiBotSchedules] = React.useState({
    monday: props.schedules[0].monday,
    tuesday: props.schedules[0].tuesday,
    wednesday: props.schedules[0].wednesday,
    thursday: props.schedules[0].thursday,
    friday: props.schedules[0].friday,
    saturday: props.schedules[0].saturday,
    sunday: props.schedules[0].sunday
  })
  const [everyDay, setEveryDay] = React.useState(props.schedules[0].everyDay || false)
  const [bankHolidays, setBankHolidays] = React.useState(props.schedules[0].bankHolidays || [])
  const [errorString, setErrorString] = React.useState('')
  const [isOpenCalendarPicker, setIsOpenCalendarPicker] = React.useState(false)
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [rangeError, setRangeError] = React.useState({})
  const [errorMsg, setErrorMsg] = React.useState('')

  const toggleCalendarPicker = () => setIsOpenCalendarPicker(!isOpenCalendarPicker)

  const updateSchedule = ({ schedule, isActiveChange = false }) => {
    setAiBotSchedules(schedule)
    if (isActiveChange) {
      setSelectedOptionAi({ value: options[2], label: options[2] })
    }
    setShouldRefresh(!shouldRefresh)
  }

  const changeDaysSelector = ({ d }) => {
    setSelectedOptionAi(d)
    let newSchedule = aiBotSchedules
    if (d.value === options[0]) {
      Object.keys(newSchedule).forEach((day) => {
        newSchedule[day].isActive = true
      })
    } else if (d.value === options[1]) {
      Object.keys(newSchedule).forEach((day) => {
        if (day === 'saturday' || day === 'sunday') {
          newSchedule[day].isActive = false
        } else {
          newSchedule[day].isActive = true
        }
      })
    }

    setAiBotSchedules(newSchedule)
    setShouldRefresh(!shouldRefresh)
  }

  const saveSchedules = () => {
    if (Object.keys(rangeError).length) {
      setErrorMsg(lang('dashboard_inconsistencies-schedule-ranges'))
      return
    } else {
      if (errorMsg) setErrorMsg('')
    }

    setIsSubmitting(true)

    const isActive = Object.values(aiBotSchedules).findIndex(elem => elem.isActive) !== -1 || everyDay
    const timeZone = props.schedules[0].timeZone

    props.saveSchedules({ ...aiBotSchedules, timeZone, everyDay, isActive, bankHolidays, tag: props.scheduleMode })
      .catch((days) => {
        if (days) {
          buildDaysString(days)
        } else {
          setErrorString('Ocurrió un error desconocido')
        }
      })
      .finally(() => {
        setIsSubmitting(false)
        props.closeModal()
      })
  }

  const buildDaysString = (days) => {
    let errorDays = ''
    days.forEach((day) => {
      switch (day) {
        case 'monday':
          if (errorDays !== '') {
            errorDays += ', '
          }
          errorDays += 'Lunes'
          break
        case 'tuesday':
          if (errorDays !== '') {
            errorDays += ', '
          }
          errorDays += 'Martes'
          break
        case 'wednesday':
          if (errorDays !== '') {
            errorDays += ', '
          }
          errorDays += 'Miércoles'
          break
        case 'thursday':
          if (errorDays !== '') {
            errorDays += ', '
          }
          errorDays += 'Jueves'
          break
        case 'friday':
          if (errorDays !== '') {
            errorDays += ', '
          }
          errorDays += 'Viernes'
          break
        case 'saturday':
          if (errorDays !== '') {
            errorDays += ', '
          }
          errorDays += 'Sábado'
          break
        case 'sunday':
          if (errorDays !== '') {
            errorDays += ', '
          }
          errorDays += 'Domingo'
          break
        default:
          break
      }
    })
    setErrorString(errorDays)
  }

  return (
    <>
      <div className='schedule-modal-office'>
        <div className='schedules-container'>
          <div className='bot-modal'>
            <div className='modal-header'>
              <div className='title-container'>
                <div className='title'>{lang(`message_${props.scheduleMode}_schedule_modal_title`)}</div>
              </div>
              <div className='close' onClick={props.closeModal}>
                <i className='fa fa-times'></i>
              </div>
            </div>
            {props.everyDay && (
              <InputControls
                label={lang(`message_${props.scheduleMode}_schedule_modal_enable`)}
                value={everyDay}
                onChange={setEveryDay}
              />
            )}
            <div className='days-selector-container'>
              <SelectWithLabel
                label={lang('dashboard_weekdays')}
                options={options.map((o) => ({ value: o, label: o }))}
                value={selectedOptionAi}
                onChange={(d) => changeDaysSelector({ d })}
              />
              {props.enableHolidays && (
                <LabelButton
                  label={lang('dashboard_holidays')}
                  text={lang('dashboard_add-holidays')}
                  imageUrl={getStaticImage('/icons/orange-brand/calendar-primary.svg')}
                  onClick={toggleCalendarPicker}
                />
              )}
            </div>
            <div className='days-range-container'>
              <DaysRange
                schedules={aiBotSchedules}
                updateSchedule={updateSchedule}
                scheduleName='aiBotSchedules'
                refresh={shouldRefresh}
                onChangeError={setRangeError}
              />
            </div>
            {(errorString || errorMsg) ? (
              <div className='error-text-container'>
                {errorString !== '' ? <span className='error-text'>{`Por favor revisa las franjas horarias de los días: ${errorString}`}</span> : null}
                {errorMsg ? <span className='error-text'>{errorMsg}</span> : null}
              </div>
            ) : null}
          </div>
        </div>
        <div className='modal-footer'>
          <div className='action-buttons'>
            <Button secondary value={lang('dashboard_save')} onClick={saveSchedules} isSubmitting={isSubmitting} />
            <Button value={lang('dashboard_cancel')} onClick={props.closeModal} />
          </div>
        </div>
      </div>
      {isOpenCalendarPicker && (
        <CalendarPicker
          mode='modal'
          initialValues={bankHolidays}
          onChange={setBankHolidays}
          modalOptions={{
            isOpen: isOpenCalendarPicker,
            toggle: toggleCalendarPicker,
            header: {
              title: lang('dashboard_holidays'),
              subtitle: lang('calendar_picker_modal_holidays_subtitle')
            },
            buttons: true
          }}
          multipleSelection
        />
      )}
    </>
  )
}

export default Index
